import { lazy } from 'react';
const ReportStockAkhir = lazy(() => import('../Report/ReportStockAkhir/Pages/ReportStockAkhir'));
const ReportKeuangan = lazy(() => import('../Report/ReportKeuangan/Pages/ReportKeuangan'));
const MasterToko = lazy(() => import('../Master/MasterToko/Pages/MasterToko'));
const ManajemenKasir = lazy(() => import('../Transaksi/Pages/ManajemenKasir/Pages/ManajemenKasir'));
const MasterUserApproval = lazy(() => import('../Master/MasterUser/Pages/MasterUserApproval'));
const MasterBudgetPromoAdd = lazy(() => import('../Master/MasterPromo/Pages/MasterBudgetPromoAdd'));
const MasterBudgetPromoEdit = lazy(() => import('../Master/MasterPromo/Pages/MasterBudgetPromoEdit'));
const MasterBudgetPromo = lazy(() => import('../Master/MasterPromo/Pages/MasterBudgetPromo'));
const MasterPromo = lazy(() => import('../Master/MasterPromo/Pages/MasterPromo'));
const MasterPromoEdit = lazy(() => import('../Master/MasterPromo/Pages/MasterPromoEdit'));
const MasterPromoAdd = lazy(() => import('../Master/MasterPromo/Pages/MasterPromoAdd'));
const MasterSupplierAdd = lazy(() => import('../Master/MasterSupplier/Pages/MasterSupplierAdd'));
const Print = lazy(() => import('../Transaksi/Pages/TransaksiJual/Print'));
const ReportTransaksi = lazy(() => import('../Report/ReportTransaksi/Pages/ReportTransaksi'));
const ReportStock = lazy(() => import('../Report/ReportStock/Pages/ReportStock'));
const MasterCustomer = lazy(() => import('../Master/MasterCustomer/Pages/MasterCustomer'));
const MasterCustomerEdit = lazy(() => import('../Master/MasterCustomer/Pages/MasterCustomerEdit'));
const MasterCustomerAdd = lazy(() => import('../Master/MasterCustomer/Pages/MasterCustomerAdd'));
const MasterSupplierEdit = lazy(() => import('../Master/MasterSupplier/Pages/MasterSupplierEdit'));
const MasterSupplier = lazy(() => import('../Master/MasterSupplier/Pages/MasterSupplier'));
const MasterUserEdit = lazy(() => import('../Master/MasterUser/Pages/MasterUserEdit'));
const MasterUserAdd = lazy(() => import('../Master/MasterUser/Pages/MasterUserAdd'));
const MasterInventoryAdd = lazy(() => import('../Master/MasterInventory/Pages/MasterInventoryAdd'));
const ProsesTransaksi = lazy(() => import('../Transaksi/Pages/TransaksiJual/ProsesTransaksi'));
const MasterInventoryEdit = lazy(() => import('../Master/MasterInventory/Pages/MasterInventoryEdit'));
const Account = lazy(() => import('../Auth/Pages/Account'));
const MasterUser = lazy(() => import('../Master/MasterUser/Pages/MasterUser'));
const MasterInventory = lazy(() => import('../Master/MasterInventory/Pages/MasterInventory'));
const Dashboard = lazy(() => import('../Dashboard/Pages/Dashboard'));
const TransaksiHistory = lazy(() => import('../Transaksi/Pages/TransaksiHistory/TransaksiHistory'));
const TransaksiJual = lazy(() => import('../Transaksi/Pages/TransaksiJual/TransaksiJual'));
const TransaksiReturnProses = lazy(() => import('../Transaksi/Pages/TransaksiReturn/Pages/TransaksiReturnProses'));
const TransaksiReturn = lazy(() => import('../Transaksi/Pages/TransaksiReturn/Pages/TransaksiReturn'));
const SignOut = lazy(() => import('../Auth/Pages/SignOut'));
const UserList = lazy(()=>import('../Auth/Pages/UserList'));
const PenerimaanBarang = lazy(()=>import('../InventoryManagement/PenerimaanBarang/Pages/PenerimaanBarang'));
const PenerimaanBarangAdd = lazy(()=>import('../InventoryManagement/PenerimaanBarang/Pages/PenerimaanBarangAdd'));
const PengeluaranBarang = lazy(()=>import('../InventoryManagement/PengeluaranBarang/Pages/PengeluaranBarang'));
const PengeluaranBarangAdd = lazy(()=>import('../InventoryManagement/PengeluaranBarang/Pages/PengeluaranBarangAdd'));
const StockOpname = lazy(()=>import('../InventoryManagement/StockOpname/Pages/StockOpname'));
const StockOpnameAdd = lazy(()=>import('../InventoryManagement/StockOpname/Pages/StockOpnameAdd'));
const StockHistory = lazy(()=>import('../InventoryManagement/StockHistory/Pages/StockHistory'));
const StockHistoryDetail = lazy(()=>import('../InventoryManagement/StockHistory/Pages/StockHistoryDetail'));

// const Calendar = lazy(() => import('../pages/Calendar'));
// const Chart = lazy(() => import('../pages/Chart'));
// const FormElements = lazy(() => import('../pages/Form/FormElements'));
// const FormLayout = lazy(() => import('../pages/Form/FormLayout'));
// const Profile = lazy(() => import('../pages/Profile'));
// const Settings = lazy(() => import('../pages/Settings'));
// const Tables = lazy(() => import('../pages/Tables'));
// const Alerts = lazy(() => import('../pages/UiElements/Alerts'));
// const Buttons = lazy(() => import('../pages/UiElements/Buttons'));

const coreRoutes = [
  {
    path: '/transaksi/jual',
    title: 'Transaksi Jual',
    component: TransaksiJual,
  },
  {
    path: '/trx-history',
    title: 'Transaksi History',
    component: TransaksiHistory,
  },
  {
    path: '/dashboard/transaksi',
    title: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/dashboard/transaksi',
    title: 'Dashboard Transaksi',
    component: Dashboard,
  },
  {
    path: '/master/inventory',
    title: 'Master Inventory',
    component: MasterInventory,
  },
  {
    path: '/master/user',
    title: 'Master User',
    component: MasterUser,
  },
  {
    path: '/master/user/edit',
    title: 'Master User Edit',
    component: MasterUserEdit,
  },
  {
    path: '/master/user/add',
    title: 'Master User Add',
    component: MasterUserAdd,
  },
  {
    path: '/master/supplier',
    title: 'Master Supplier',
    component: MasterSupplier,
  },
  {
    path: '/master/supplier/edit',
    title: 'Master Supplier Edit',
    component: MasterSupplierEdit,
  },
  {
    path: '/master/supplier/add',
    title: 'Master Supplier Add',
    component: MasterSupplierAdd,
  },
  {
    path: '/master/promo',
    title: 'Master Promo',
    component: MasterPromo,
  },
  {
    path: '/master/promo/budget',
    title: 'Master Budget Promo',
    component: MasterBudgetPromo,
  },
  {
    path: '/master/promo/budget/add',
    title: 'Master Budget Promo',
    component: MasterBudgetPromoAdd,
  },
  {
    path: '/master/promo/budget/edit',
    title: 'Master Budget Promo',
    component: MasterBudgetPromoEdit,
  },
  {
    path: '/master/promo/edit',
    title: 'Master Promo Edit',
    component: MasterPromoEdit,
  },
  {
    path: '/master/promo/add',
    title: 'Master Promo Add',
    component: MasterPromoAdd,
  },
  {
    path: '/master/customer',
    title: 'Master Customer',
    component: MasterCustomer,
  },
  {
    path: '/master/customer/edit',
    title: 'Master Customer Edit',
    component: MasterCustomerEdit,
  },
  {
    path: '/master/customer/add',
    title: 'Master Customer Add',
    component: MasterCustomerAdd,
  },
  {
    path: '/master/toko',
    title: 'Master Toko',
    component: MasterToko,
  },
  {
    path: '/auth/account/setting',
    title: 'Account Setting',
    component: Account,
  },
  {
    path: '/master/inventory/edit',
    title: 'Master Inventory Edit',
    component: MasterInventoryEdit,
  },
  {
    path: '/master/inventory/add',
    title: 'Master Inventory Add',
    component: MasterInventoryAdd,
  },
  {
    path: '/transaksi/jual/proses',
    title: 'Proses Transaksi Jual',
    component: ProsesTransaksi,
  },
  {
    path: '/transaksi/history',
    title: 'Transaksi History',
    component: TransaksiHistory,
  },
  {
    path: '/transaksi/return',
    title: 'Transaksi Return',
    component: TransaksiReturn,
  },
  {
    path: '/transaksi/manajemen-kasir',
    title: 'Manajemen Kasir',
    component: ManajemenKasir,
  },
  {
    path: '/transaksi/return/proses',
    title: 'Transaksi Return',
    component: TransaksiReturnProses,
  },
  {
    path: '/laporan/inventory',
    title: 'Laporan Stock Barang',
    component: ReportStock,
  },
  {
    path: '/laporan/transaksi',
    title: 'Laporan Transaksi',
    component: ReportTransaksi,
  },
  {
    path: '/laporan/stock/akhir',
    title: 'Laporan Stock Akhir',
    component: ReportStockAkhir,
  },
  {
    path: '/laporan/keuangan',
    title: 'Laporan Keuangan',
    component: ReportKeuangan,
  },
  {
    path: '/print',
    title: 'Print Struk',
    component: Print,
  },
  {
    path: '/auth/signout',
    title: '',
    component: SignOut,
  },
  {
    path: '/administrator/user',
    title: '',
    component: UserList,
  },
  {
    path: '/administrator/user/approval',
    title: '',
    component: MasterUserApproval,
  },
  {
    path: '/inventory-management/pengeluaran',
    title: '',
    component: PengeluaranBarang,
  },
  {
    path: '/inventory-management/pengeluaran/new',
    title: '',
    component: PengeluaranBarangAdd,
  },
  {
    path: '/inventory-management/penerimaan',
    title: '',
    component: PenerimaanBarang,
  },
  {
    path: '/inventory-management/penerimaan/new',
    title: '',
    component: PenerimaanBarangAdd,
  },
  {
    path: '/inventory-management/opname',
    title: '',
    component: StockOpname,
  },
  {
    path: '/inventory-management/opname/new',
    title: '',
    component: StockOpnameAdd,
  },
  {
    path: '/inventory-management/stock-history',
    title: '',
    component: StockHistory,
  },
  {
    path: '/inventory-management/stock-history/detail',
    title: '',
    component: StockHistoryDetail,
  },
 
//   {
//     path: '/forms/form-elements',
//     title: 'Forms Elements',
//     component: FormElements,
//   },
//   {
//     path: '/forms/form-layout',
//     title: 'Form Layouts',
//     component: FormLayout,
//   },
//   {
//     path: '/tables',
//     title: 'Tables',
//     component: Tables,
//   },
//   {
//     path: '/settings',
//     title: 'Settings',
//     component: Settings,
//   },
//   {
//     path: '/chart',
//     title: 'Chart',
//     component: Chart,
//   },
//   {
//     path: '/ui/alerts',
//     title: 'Alerts',
//     component: Alerts,
//   },
//   {
//     path: '/ui/buttons',
//     title: 'Buttons',
//     component: Buttons,
//   },
];

const routes = [...coreRoutes];
export default routes;
